import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { chat_config_key, ChatConfig, get_config, update_config } from './management'
import { Field, Form, Formik } from 'formik'

export function ChatConfiguration({ username }) {
  const queryClient = useQueryClient()

  const initialData = {
    username,
    user: '',
    password: '',
    host: '',
    showTechnicalItems: false,
  }

  const queryKey = chat_config_key(username)
  const queryFn = () => get_config(username).catch(err => {console.warn(err); return initialData})

  const { data, status } = useQuery<ChatConfig>({
    queryKey,
    queryFn,
    initialData,
  })
  console.log(data)

  const postMutation = useMutation<ChatConfig, Error, ChatConfig>({
    mutationFn: (config: ChatConfig) => update_config(config),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey})
    },
  })
  const onSubmit = postMutation.mutateAsync

  return (
    <div className='py-4 max-w-sm'>
      <h4 className='mb-2'>Chat Configuration</h4>
      <ChatConfigurationForm {...{ initialValues: {username, ...data}, onSubmit }} />
    </div>
  )
}

function ChatConfigurationForm({ initialValues, onSubmit }: { initialValues: ChatConfig; onSubmit: (c: ChatConfig) => Promise<any> }) {
  return (
    <Formik {...{ initialValues, onSubmit }} enableReinitialize>
      <Form className="flex flex-col gap-2">
        <Field name="username" type="hidden" />
        <Field name="user" className="form-input" placeholder="User" />
        <Field name="password" className="form-input" placeholder="Password" type="password" />
        <Field name="host" className="form-input" placeholder="Host" />
        <label className="inline-flex items-center">
          <Field name="showTechnicalItems" type="checkbox" className="form-checkbox" />
          <span className="ml-2 text-slate-800">Show technical items</span>
        </label>
        <button type="submit" className="btn-primary"> Save </button>
        <button type="reset" className="btn-secondary"> Reset </button>
      </Form>
    </Formik>
  )
}
